import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import { post } from "../../../actions/general";
import { editUser } from "../../../store/user/actions";

import Form, { InputPassword, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import { ICloseProp } from "../interfaces";
import messages from "./messages";

const NewPassword = ({ close }: ICloseProp) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [loading, setLoading] = useState(false);
    const [validationPassword, setValidationPassword] = useState<undefined | string>(undefined);
    const [validationPassword2, setValidationPassword2] = useState<undefined | string>(undefined);
    const newPassword = () => {
        if (password.length === 0) {
            setValidationPassword("required");
        }
        if (password2.length === 0) {
            setValidationPassword2("required");
        }
        if (password2.length === 0 || password.length === 0) return;
        if (password.length < 8) {
            setValidationPassword("passwordTooShort");
            return
        }
        if (password !== password2) {
            setValidationPassword("passwordDoNotMatch");
            setValidationPassword2("1");
            return
        }
        setLoading(true);
        dispatch(post("new-password", { password }, res => {
            const { data } = res;
            if (data.success) {
                dispatch(editUser(data.user));
                close();
            } else {
                setValidationPassword("unknownError")
                setLoading(false);
            }
        }));
    };
    const change = (e: React.FormEvent<HTMLInputElement>) => {
        if (e.currentTarget.name === "password"){
            setPassword(e.currentTarget.value);
        } else if (e.currentTarget.name === "password2"){
            setPassword2(e.currentTarget.value);
        }
        setValidationPassword(undefined);
        setValidationPassword2(undefined);
    }
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.createPassword} />
                </Title>
                <InputPassword
                    required
                    validation={validationPassword}
                    label={formatMessage(messages.newPassword)}
                    value={password}
                    name={"password"}
                    onChange={change}
                />
                <InputPassword
                    required
                    validation={validationPassword2}
                    label={formatMessage(messages.newPasswordAgain)}
                    value={password2}
                    name={"password2"}
                    onChange={change}
                />
                <Submit onClick={newPassword} loading={loading}>
                    <FormattedMessage {...messages.createPassword} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default NewPassword;
